import React from 'react';
import { connect } from 'react-redux';
import { isEmpty, isNull } from 'lodash';
import { Icon } from 'ui';
import IndexTableBodyCell from '../../../../shared/index/table/body_cell';
import RowTags from '../../../../shared/index/row_tags';
import ShareButton from '../share_button';
import * as actions from '../../../../../actions/shared/index/filter';
import { contentTagsSelector } from '../../../../../selectors';

const ContentTitleCell = ({
  title,
  urls,
  type,
  lessons,
  description,
  tagsData,
  filterByTag,
  hasTags,
  id,
  scorm,
  isDraft,
  features,
  userCanUpdateContent,
  isCertification,
}) => (
  <IndexTableBodyCell size="xl" name="title" split>
    <div>
      {!!urls.overview && (
        <a href={urls.overview}>
          <TitleIcon type={type} isCertification={isCertification} />
          {title}
        </a>
      )}
      {!urls.overview && (
        <span className="btn-disabled">
          <TitleIcon type={type} isCertification={isCertification} />
          {title}
        </span>
      )}
      <div className="Index-tableSecondaryField">
        {scorm && <TypeBadge label="SCORM" icon="scorm" withComma={hasTags} />}
        {hasTags && (
          <RowTags
            data={tagsData}
            href="?tags[]={{key}}"
            onTagClick={filterByTag}
          />
        )}
      </div>
    </div>
    <div className="IndexAction-container">
      {!!urls.share && <ShareButton url={urls.share} />}
      {!!urls.edit && !scorm && userCanUpdateContent && (
        <a
          className="IndexAction-button IndexAction-button--square"
          target={`lesson_edit_${id}`}
          href={urls.edit}
        >
          <Icon name="edit" />
        </a>
      )}
    </div>
  </IndexTableBodyCell>
);

const TitleIcon = ({ type, isCertification }) => (
  <span>
    {(type === 'path' || type === 'practice/container') && !isCertification && (
      <Icon
        className="mr-4 c-brand-gray-dark"
        name={type === 'practice/container' ? 'star_outline' : type}
      />
    )}
    {type === 'path' && isCertification && (
      <Icon className="mr-4 c-brand-gray-dark" name="new-certification-badge" />
    )}
  </span>
);

const TypeBadge = ({ icon, label, withComma }) => (
  <span>
    <span className="RoleTag">
      {icon && <Icon name={icon} />} {label}
    </span>
    {withComma && ', '}
  </span>
);

const mapStateToProps = () => {
  // To retain memoization, each instance of the component needs its own
  // private copy of the selector.
  const getTags = contentTagsSelector();
  // this function will be used as mapStateToProps() for each component instance
  return (state, { tags, lastModified, index, type, publishedAt }) => ({
    hasTags: !isEmpty(tags),
    isDraft: type === 'path' && isNull(publishedAt),
    tagsData: getTags(state, tags),
    userCanUpdateContent: state.data.meta.currentUser.canUpdateContent,
  });
};
const mapDispatchToProps = dispatch => ({
  filterByTag: id => {
    dispatch(actions.filterByTag([id]));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentTitleCell);
